import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";

const reveal = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] },
};

const testimonials = [
  {
    quote:
      "Bhaaskar Productions turned our Annual Day into a spectacle. The LED wall, lighting and sound were flawless from the first cue to the final performance.",
    name: "Principal",
    org: "Oak Valley International School",
  },
  {
    quote:
      "Their team handled our College Fest end-to-end — huge stage, powerful visuals and zero glitches in front of thousands. Truly professional.",
    name: "Cultural Head",
    org: "City Degree College",
  },
  {
    quote:
      "From the grand entrance arch to the main stage, every detail was engineered perfectly. On-time setup and a crew you can trust.",
    name: "Event Coordinator",
    org: "Sri Vidya Institutions",
  },
];

export default function Testimonials() {
  return (
    <section className="bg-[#050505] border-t border-white/10 py-24 md:py-32" data-testid="testimonials-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <motion.div {...reveal} className="mb-14">
          <span className="text-xs tracking-[0.35em] text-[#F5B841]">TRUSTED BY SCHOOLS &amp; COLLEGES</span>
          <h2 className="font-display text-4xl md:text-6xl tracking-tighter mt-4">What our clients say</h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {testimonials.map((t, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: i * 0.1, duration: 0.6 }}
              data-testid={`testimonial-${i}`}
              className="bg-[#0a0a0a] border border-white/10 p-8 flex flex-col hover:border-[#F5B841]/40 transition-colors"
            >
              <Quote className="w-8 h-8 text-[#F5B841]" />
              <blockquote className="text-white/75 text-lg font-light mt-6 flex-1">“{t.quote}”</blockquote>
              <div className="flex gap-1 mt-6">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} className="w-4 h-4 fill-[#F5B841] text-[#F5B841]" />
                ))}
              </div>
              <figcaption className="mt-4 pt-4 border-t border-white/10">
                <div className="text-white font-medium">{t.name}</div>
                <div className="text-white/45 text-sm">{t.org}</div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
